import { asText, Content, isFilled } from '@prismicio/client';

type WithVideoProps = {
  content: Content.PageHeroHeadlineSliceWithVideoPrimary;
};

export const WithVideo = ({ content }: WithVideoProps) => {
  const { video, video_caption } = content;

  if (!isFilled.linkToMedia(video)) {
    return null;
  }

  const { url } = video;

  return (
    <figure>
      <video controls={true}>
        <source src={url} type="video/mp4" />
        {asText(video_caption)}
      </video>
    </figure>
  );
};
